import React, { useContext } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Banner, BannerNote, Button } from '@ferris/react';
import PropTypes from 'prop-types';
import AppActions from '../../actions/app';
import TranslationUtil from '../../utils/TranslationUtil';
import { VrboCtx } from '../../contexts/vrbo';

export const ErrorCodes = {
    INCOMPLETE_PROPERTY: 'Address information is required to create a property'
};

const getPropsFromState = (state) => {
    const { app } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const {
        createPropertyError
    } = app;
    const genericCreatePropertyErrorMessage = translations.getTranslation('Vrbo.lyp.estimate.property.creation.error.message');
    const incompletePropertyErrorMessage = translations.getTranslation('Vrbo.lyp.estimate.property.creation.incomplete.error.message');
    const incompletePropertyErrorLinkMessage = translations.getTranslation('Vrbo.lyp.estimate.property.creation.incomplete.error.message.link');
    return {
        createPropertyErrorTitle: translations.getTranslation('Vrbo.lyp.estimate.property.creation.error.title'),
        createPropertyError,
        genericCreatePropertyErrorMessage,
        incompletePropertyErrorMessage,
        incompletePropertyErrorLinkMessage
    };
};

export default function PropertyCreationErrorBanner(props) {
    const {
        createPropertyError,
        createPropertyErrorTitle,
        genericCreatePropertyErrorMessage,
        incompletePropertyErrorMessage,
        incompletePropertyErrorLinkMessage
    } = useSelector(getPropsFromState, shallowEqual);
    if (!createPropertyError) return null;

    const {
        isDismissable
    } = props;

    const dispatch = useDispatch();
    const dismissAlert = () => {
        dispatch(AppActions.setCreatePropertyError(''));
    };

    const {
        restartPropertyCreationProcess
    } = useContext(VrboCtx) || {};

    function DefaultErrorNote() {
        return (
            <span>{ genericCreatePropertyErrorMessage }</span>
        );
    }

    function IncompletePropertyErrorNote() {
        return (
            <>
                {incompletePropertyErrorMessage}
                <Button
                    htmlButtonType="button"
                    type="link"
                    variant="link-standard"
                    id="complete-property-error-link"
                    classes="complete-property-error-link"
                    onClick={restartPropertyCreationProcess}
                >
                    {incompletePropertyErrorLinkMessage}
                </Button>
            </>
        );
    }

    function ErrorNote() {
        switch (createPropertyError) {
        case ErrorCodes.INCOMPLETE_PROPERTY:
            return (<IncompletePropertyErrorNote />);
        default:
            return (<DefaultErrorNote />);
        }
    }

    return (
        <Banner
            classes="lead-form-banner"
            type="error"
            dismiss={isDismissable}
            dismissAltText="Close"
            onDismiss={dismissAlert}
            headline={createPropertyErrorTitle}
            scope="page"
            stacked
        >
            <BannerNote>
                <ErrorNote />
            </BannerNote>
        </Banner>
    );
}

PropertyCreationErrorBanner.propTypes = {
    isDismissable: PropTypes.bool
};

PropertyCreationErrorBanner.defaultProps = {
    isDismissable: true
};
